import { OverviewModalForm } from './OverviewModalForm';

interface OverviewModalProps {
	isOpen: boolean;
	onClose: () => void;
}

export const OverviewModal = ({ isOpen, onClose }: OverviewModalProps) => {
	if (!isOpen) {
		return null;
	}

	return (
		<OverviewModalForm
			isOpen={isOpen}
			onClose={onClose}
		/>
	);
};
